import { Helmet } from "react-helmet-async";

const MetaTitle = ({ title }) => {
    const pageTitle = title?.includes("|") ? title : `${title} | Elee Controls Pvt.Ltd`;

    return (
        <Helmet>
            <title>{pageTitle}</title>
        </Helmet>
    );
};

export default MetaTitle;
